(() => {
  const section = document.querySelector('#iphone-library');
  const panel = section?.querySelector('.ys-library-preview');
  const grid = panel?.querySelector('.ys-library-grid');
  const viewport = panel?.querySelector('.ys-library-window');
  if (!grid || panel.dataset.exploreParallax) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let measureNeeded = true;
  let travel = 0;
  const setProperty = (name, value) => {
    if (panel.style.getPropertyValue(name) !== value) panel.style.setProperty(name, value);
  };
  const update = () => {
    frame = 0;
    if (!panel.isConnected) { observer.disconnect(); return; }
    if (measureNeeded) {
      const cards = [...grid.children];
      if (cards.length < 6) return;
      const height = cards[5].offsetTop + cards[5].offsetHeight - cards[0].offsetTop;
      if (height <= 0) return;
      travel = Math.max(0, grid.offsetHeight - (viewport?.clientHeight || height));
      setProperty('--explore-window-height', `${height}px`);
      measureNeeded = false;
    }
    panel.dataset.exploreParallax = motion.matches ? 'static' : 'active';
    const start = innerHeight * 0.9;
    const end = innerHeight * 0.1 - panel.offsetHeight;
    const progress = motion.matches ? 0 : Math.min(1, Math.max(0,
      (start - panel.getBoundingClientRect().top) / Math.max(1, start - end)));
    setProperty('--explore-shift', `${(-travel * progress).toFixed(2)}px`);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const measure = () => { measureNeeded = true; schedule(); };
  const observer = new ResizeObserver(measure);
  observer.observe(grid);
  observer.observe(section);
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', measure, { passive: true });
  panel.addEventListener('load', measure, true);
  motion.addEventListener('change', measure);
  document.fonts?.ready.then(measure);
  measure();
})();
